window.addEventListener("DOMContentLoaded", () => {
  if ($(".mobile_buy_button_wrapper").length) {
    // si la fenêtre fait moins que 750px
    if (window.innerWidth < 750) {
      // Si le footer est visible
      if (!isInViewport($(".product_form_actions").first().get(0))) {
        // On cache le buy button
        $(".mobile_buy_button_wrapper").slideDown(200);

        // Si le bouton ".product_form_actions" est au dessus du viewport (une fois qu'on a scrollé), on affiche le buy button
        // Valeur du scroll en hauteur
        /* var scroll_top = $(window).scrollTop();
        if (scroll_top > $(".product_form_actions").first().offset().top) {
          $(".mobile_buy_button_wrapper").slideDown(200);
        } else {
          $(".mobile_buy_button_wrapper").slideUp(200);
        } */
      } else {
        // Sinon on l'affiche
        $(".mobile_buy_button_wrapper").slideUp(200);
      }
    }

    $(window).scroll(function () {
      if (window.innerWidth < 750) {
        // Si le footer est visible
        if (!isInViewport($(".product_form_actions").first().get(0))) {
          // On cache le buy button
          $(".mobile_buy_button_wrapper").slideDown(200);

          // Si le bouton ".product_form_actions" est au dessus du viewport (une fois qu'on a scrollé), on affiche le buy button
          // Valeur du scroll en hauteur
          /*  var scroll_top = $(window).scrollTop();
          if (scroll_top > $(".product_form_actions").first().offset().top) {
            $(".mobile_buy_button_wrapper").slideDown(200);
          } else {
            $(".mobile_buy_button_wrapper").slideUp(200);
          } */
        } else {
          // Sinon on l'affiche
          $(".mobile_buy_button_wrapper").slideUp(200);
        }
      }
    });

    // Au clic sur le bouton ".mobile_buy_button_wrapper button", on scroll la page de façon smooth jusqu'à l'élément "<product-form>"
    $(".mobile_buy_button_wrapper button").click(function (e) {
      e.preventDefault();
      e.stopPropagation();

      // On scroll la page de façon smooth jusqu'à l'élément "<product-form>", de façon a ce que ce dernier soit centré dans la fenêtre
      $("html, body").animate(
        {
          scrollTop: $(".product_form_actions").first().offset().top - window.innerHeight / 2 + $(".product_form_actions").first().outerHeight() / 2,
        },
        200
      );
    });
  }
});

if (!customElements.get("product-page")) {
  class ProductPage extends HTMLElement {
    constructor() {
      super();

      this.base_url = this.dataset.url;
    }

    /**
     * @description Called when the element is added to the DOM
     */
    connectedCallback() {}

    variant_options_changed() {
      // On récupère les options sélectionnées
      var options_values = this.selected_option_values;

      // On construit l'url avec les options sélectionnées
      var url = this.base_url;

      if (options_values.length > 0) {
        url += "?option_values=";
      }

      options_values.forEach((value) => {
        url += value + ",";
      });

      // On supprime le dernier caractère
      url = url.slice(0, -1);

      // On redirige vers l'url
      /* const sections_to_render = this.sections_to_render(); */

      // On transform les sections en paramètres de l'url (sections[]=...&sections[]=...)
      url += `&sections[]=${this.sectionId}`;

      fetch(url, { cache: "no-store" })
        .then((response) => {
          //window.history.replaceState({}, "", "https://www.weill.com/products/robe-en-crepe-de-laine-col-bardot-135013-1072e?variant=50864075735382");
          return response.text();
        })
        .then((state) => {
          const parsed_state = JSON.parse(state);
          const elementToReplace = document.getElementById("shopify-section-" + this.sectionId);
          const new_html = new DOMParser().parseFromString(parsed_state[this.sectionId], "text/html").querySelector("#shopify-section-" + this.sectionId).innerHTML;
          const variantId = new DOMParser().parseFromString(new_html, "text/html").querySelector("input[name='id']").value;
          this.update_url(variantId);
          const input_test = this.querySelector('input[name="id"]');
          input_test.value = variantId ?? "";
          input_test.dispatchEvent(new Event("change", { bubbles: true }));

          elementToReplace.innerHTML = new_html;

          // Tous les scripts qui contiennent kleep dans l'atribut src sont conservés pour réappliquer le fonctionnement hover sur les labels
          const keepScriptsTags = document.querySelectorAll("script[src*='kleep-reco']");
          keepScriptsTags.forEach((keepScriptTag) => {
            const newScriptTag = document.createElement("script");
            Array.from(keepScriptTag.attributes).forEach((attribute) => {
              newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(keepScriptTag.innerHTML));
            keepScriptTag.parentNode.replaceChild(newScriptTag, keepScriptTag);
          });

          if (typeof window.KleepSDK !== "undefined") {
            kleepLoadContent();
          }
        });
    }

    update_url(variantId) {
      window.history.replaceState({}, "", `${this.base_url}${variantId ? `?variant=${variantId}` : ""}`);
    }

    get selected_option_values() {
      return Array.from(this.querySelectorAll("variant-picker select option[selected], variant-picker input:checked")).map(({ dataset }) => dataset.optionValueId);
    }

    /**
     * @description Retourne les sections à rendre après un call ajax (Mise à jour de la quantité)
     * @returns {Array}
     */
    /* sections_to_render() {
      return [
        {
          id: "product_page",
          section: "product",
          selector: "product-page",
        },
      ];
    } */

    get sectionId() {
      return this.dataset.sectionId;
    }
  }

  customElements.define("product-page", ProductPage);

  // Ajout au panier
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector("form");
      this.variantIdInput.disabled = false;
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));

      this.cart = document.querySelector("cart-drawer");
      this.submitButton = this.querySelector('[type="submit"]');
      // this.submitButtonText = this.submitButton.querySelector("span");

      // if (this.cart) this.submitButton.setAttribute("aria-haspopup", "dialog");

      this.hideErrors = this.dataset.hideErrors === "true";
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute("aria-disabled") === "true") return;

      this.handleErrorMessage();

      this.submitButton.setAttribute("aria-disabled", true);
      this.submitButton.classList.add("loading");
      // this.querySelector(".loading__spinner").classList.remove("hidden");

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          "sections",
          this.cart.sections_to_render().map((section) => section.section)
        );
        formData.append("sections_url", window.location.pathname);
        // this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          // En cas d'erreur
          if (response.status) {
            /* publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.errors || response.description,
              message: response.message,
            }); */
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButtonText.classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          /* const startMarker = CartPerformance.createStartingMarker("add:wait-for-subscribers");
          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
              cartData: response,
            }).then(() => {
              CartPerformance.measureFromMarker("add:wait-for-subscribers", startMarker);
            }); */
          this.error = false;
          const quickAddModal = this.closest("quick-add-modal");

          this.cart.render_contents(response);

          /* if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(response);
            });
          } */
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          //this.querySelector(".loading__spinner").classList.add("hidden");
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product_form_error_wrapper");
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product_form_error_message");

      this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute("disabled", "disabled");
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute("disabled");
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector("[name=id]");
    }
  }

  customElements.define("product-form", ProductForm);
}

if (!customElements.get("tabs-component")) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();

      this.tabs_wrapper = this.querySelector(".product_tabs");
      this.tabs = this.tabs_wrapper.querySelectorAll("span:not(.cursor)");
      this.cursor = this.tabs_wrapper.querySelector(".cursor");

      this.contents_wrapper = this.querySelector(".product_tabs_content_wrapper");
      this.contents = this.contents_wrapper.querySelectorAll(".product_tab_content");
      this.see_more = this.contents_wrapper.querySelectorAll(".see_more");
    }

    connectedCallback() {
      this.initCursor();
      // Comportement click sur les tabs
      this.tabs.forEach((tab) => {
        tab.addEventListener("click", this.onTabClick.bind(this));
        tab.addEventListener("mouseover", this.onTabHover.bind(this));
        tab.addEventListener("mouseleave", this.onTabMouseLeave.bind(this));
      });

      this.see_more.forEach((see_more) => {
        see_more.addEventListener("click", this.onSeeMoreClick.bind(this));
      });
    }

    initCursor() {
      // On récupère la position du tab active
      const activeTab = this.tabs_wrapper.querySelector("[active]");
      if (!activeTab) return;
      const activeTabPosition = activeTab.offsetLeft;
      this.cursor.style.left = activeTabPosition + "px";
      this.cursor.style.width = activeTab.offsetWidth + "px";
    }

    onTabClick(evt) {
      // On place le paramètre active sur le tab cliqué, on supprime le paramètre active sur les autres tabs
      this.tabs.forEach((tab) => {
        tab.removeAttribute("active");
      });

      const activeTab = evt.target;
      activeTab.setAttribute("active", "active");

      // On récupère la position du tab active et on déplace le curseur
      const activeTabPosition = activeTab.offsetLeft;
      this.cursor.style.left = activeTabPosition + "px";
      this.cursor.style.width = activeTab.offsetWidth + "px";

      // On affiche le contenu du tab active
      this.contents.forEach((content) => {
        content.classList.remove("open");
      });
      const activeContent = this.contents_wrapper.querySelector(`[data-zone-id="${activeTab.dataset.target}"]`);
      activeContent.classList.add("open");
    }

    onTabHover(evt) {
      // On récupère la position du tab hover
      const activeTab = evt.target;
      const activeTabPosition = activeTab.offsetLeft;
      this.cursor.style.left = activeTabPosition + "px";
      this.cursor.style.width = activeTab.offsetWidth + "px";
    }

    onTabMouseLeave(evt) {
      // On récupère la position du tab active
      const activeTab = this.tabs_wrapper.querySelector("[active]");
      if (!activeTab) return;
      const activeTabPosition = activeTab.offsetLeft;
      this.cursor.style.left = activeTabPosition + "px";
      this.cursor.style.width = activeTab.offsetWidth + "px";
    }

    onSeeMoreClick(evt) {
      const content = evt.target.closest(".product_tab_content").querySelector(".clamped");
      content.classList.remove("clamped");

      // On retire du DOM le see_more
      evt.target.remove();
    }
  }

  customElements.define("tabs-component", TabsComponent);
}

if (!customElements.get("product-media-gallery")) {
  class ProductMediaGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeSlideshow();
    }

    initializeSlideshow() {
      new Swiper(this.querySelector(".swiper"), {
        slidesPerView: 1,
        navigation: false,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
          type: "bullets",
          enabled: true,
        },
        mousewheel: {
          enabled: false,
        },
        breakpoints: {
          768: {
            direction: "vertical",
            mousewheel: {
              enabled: true,
            },
            pagination: {
              enabled: true,
            },
          },
        },
        on: {
          init: function (swiper) {
            // On set la hauteur du swiper à la hauteur de la première image
            $(".swiper").css("height", $(".swiper-slide").eq(0).find("img").first().height());
          },
          resize: function (swiper) {
            // On set la hauteur du swiper à la hauteur de la première image
            $(".swiper").css("height", $(".swiper-slide").eq(0).find("img").first().height());
          },
        },
      });
    }
  }

  customElements.define("product-media-gallery", ProductMediaGallery);
}

if (!customElements.get("estimated-delivery")) {
  class EstimatedDelivery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.calculateDeliveryDate();
    }

    // Entre 3 et 5 jours ouvrés "hors dimanche et jours fériés"
    calculateDeliveryDate() {
      const minDeliveryDate = new Date();
      const maxDeliveryDate = new Date();

      minDeliveryDate.setDate(minDeliveryDate.getDate() + 3);
      maxDeliveryDate.setDate(maxDeliveryDate.getDate() + 5);

      // Gestion des dimanches et jours fériés
      const isWeekend = minDeliveryDate.getDay() === 0;
      if (isWeekend) {
        minDeliveryDate.setDate(minDeliveryDate.getDate() + 1);
        maxDeliveryDate.setDate(maxDeliveryDate.getDate() + 1);
      }

      // Idem pour le maxDeliveryDate
      const isWeekendMax = maxDeliveryDate.getDay() === 0;
      if (isWeekendMax) {
        maxDeliveryDate.setDate(maxDeliveryDate.getDate() + 1);
      }

      // On écrit le jour et le mois en version courte, en prenant en compte la locale
      const minDeliveryDateShort = minDeliveryDate.toLocaleDateString("fr-FR", { day: "2-digit", month: "short" });
      const maxDeliveryDateShort = maxDeliveryDate.toLocaleDateString("fr-FR", { day: "2-digit", month: "short" });
      this.querySelector(".delivery_date").textContent = minDeliveryDateShort + " " + maxDeliveryDateShort;
    }
  }

  customElements.define("estimated-delivery", EstimatedDelivery);
}

window.addEventListener("DOMContentLoaded", () => {
  cross_selling_titles = document.querySelectorAll(".cross_selling_titles h2");
  cross_selling_titles.forEach((title) => {
    title.addEventListener("click", () => {
      let target = title.dataset.target;
      let that = title;

      // On retire la class open des .cross_selling_items, et on l'ajoute à la target
      document.querySelectorAll(".cross_selling_items").forEach((item) => {
        if (item.id === target) {
          item.classList.add("open");
        } else {
          item.classList.remove("open");
        }
      });

      // On retire la class active des .cross_selling_titles sauf sur celui qui a été cliqué
      document.querySelectorAll(".cross_selling_titles h2").forEach((title) => {
        if (title === that) {
          title.classList.add("active");
        } else {
          title.classList.remove("active");
        }
      });
    });
  });
});
